import { ScheduledScreen } from '@shared/types';
import { Component, Prop, h, State, Watch } from '@stencil/core';
import { Countdown, countdown } from './CountdownService';
import { CountdownClock } from './CountdownClock';

@Component({
  tag: 'countdown-screen',
  styleUrl: 'countdown-screen.scss'
})
export class CountdownScreen {

  @Prop() screen: ScheduledScreen;

  @State() countdown?: Countdown;
  @State() title?: string;
  @State() end?: string;

  private stop?: () => void;

  @Watch('screen')
  watchPropHandler(screen?: ScheduledScreen): void {
    this.startCounter(screen);
  }

  componentWillLoad(): void {
    this.startCounter(this.screen);
  }

  disconnectedCallback(): void {
    this.stop?.();
  }

  render() {
    const { title, end, countdown } = this;
    if (countdown.seconds < 0) {
      return (
        <div class="outer col inset--0 text--center">
          <div class="inner col spacing--m">
            {end}
          </div>
        </div>
      );
    }
    return (
      <div class="outer col inset--0 text--center">
        <div class="inner col spacing--m">
          {title && <div class="title">{title}</div>}
          {countdown && <CountdownClock countdown={countdown} />}
        </div>
      </div>
    );
  }

  startCounter(screen?: ScheduledScreen): void {
    try {
      const { title, end, target } = JSON.parse(screen?.data || "{}");
      this.title = title;
      this.end = end;
      if (target) {
        this.stop = countdown(
          target,
          countdown => this.countdown = countdown
        );
      }
    } catch(error) {
      console.log({ error });
      this.title = '♥.CHAPEL.AT'
    }
  }
}
